import videojs from 'video.js';

const Plugin = videojs.getPlugin('plugin');
const Button = videojs.getComponent('MenuButton');

class SummaryButton extends Button {
  constructor(player, options) {
    super(player, options);
    this.addClass('scaleup-summary');

    this.setAttribute('id', this.player_.id() + '-scaleup-summary');
    this.controlText('Resumo');

    this.menuButton_.addClass('scaleup-summary-button');

    if (this.player().hasClass('scaleup-summary-button--active')) {
      this.el().classList.add('vjs-toogle-btn');
    }
  }

  toggleClass(isSummary) {
    if(isSummary) {
      this.player().addClass('scaleup-summary-button--active');
    } else {
      this.player().removeClass('scaleup-summary-button--active');
    }
  }

  handleClick() {
    const data = this?.parentComponent_?.options_?.playerOptions?.plugins?.summaryPlugin;

    if (!data?.enableSummaryButton) {
      return;
    }

    const isSummaryNow = this.el().classList.contains('vjs-toogle-btn');

    if (data?.setSummary) {
      this.toggleClass(!isSummaryNow);
      data?.setSummary(!isSummaryNow);
    }

    this.el().classList.toggle('vjs-toogle-btn');
  }
}

class SummaryPlugin extends Plugin {
  constructor(player, options) {
    super(player);

    const self = this;

    this.options = {...options};

    this.player.ready(() => {
      if (this.options.isSummary) {
        this.player.addClass('scaleup-summary-button--active');
      }

      if (this.options.createSummaryButton) {
        this.player.addClass('scaleup-summary-button');
        this.registerSummaryButton();
      }
    });
  }

  registerSummaryButton() {
    videojs.registerComponent('summaryButton', SummaryButton);
    this.player.getChild('controlBar').addChild('summaryButton');
    this.buildUI();
  }

  buildUI() {
    const summaryToggle = this.player.getChild('controlBar').getChild('summaryButton').el();

    const switchEl = videojs.dom.createEl('div', {
      className: 'scaleup-summary scaleup-switch-wrapper',
    });
    const switchBG = videojs.dom.createEl('div', {
      className: 'scaleup-summary scaleup-switch-background',
    });
    const switchIcon = videojs.dom.createEl('i', {
      className: 'fa-solid fa-bolt',
    });

    if (!this.options.enableSummaryButton) {
      summaryToggle.classList.add('vjs-disabled');
    }

    switchBG.appendChild(switchIcon);
    switchEl.appendChild(switchBG);
    summaryToggle.appendChild(switchEl);
  }
}

SummaryPlugin.defaultState = {};

videojs.registerPlugin('summaryPlugin', SummaryPlugin);

export default SummaryPlugin;
